import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import useCsvUpload from "../../hooks/useCsvUpload";
import LoadingView from "./LoadingView";
import LogsView from "./LogsView";
import ModalActions from "./ModalActions";
import UploadView from "./UploadView";
import ValidationErrorView from "./ValidationErrorView";
import ValidationView from "./ValidationView";
function ModalBody() {
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 1),
    state = _useCsvUpload2[0];
  var View;
  if (state.view === "validate") {
    View = ValidationView;
  } else if (state.view === "upload") {
    View = UploadView;
  } else if (state.view === "loading") {
    View = LoadingView;
  } else if (state.view === "validation-error") {
    View = ValidationErrorView;
  } else if (state.view === "logs") {
    View = LogsView;
  } else {
    var Default = function Default() {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    };
    View = Default;
  }
  var showActions = state.view === "validate";
  return /*#__PURE__*/React.createElement("div", {
    className: "max-h-[400px] h-[400px] flex flex-col overflow-y-scroll"
  }, /*#__PURE__*/React.createElement(View, null), showActions && /*#__PURE__*/React.createElement(ModalActions, null));
}
export default ModalBody;